import React from "react";
import { useTranslation } from "react-i18next";

const TapPaymentFailedCard: React.FC = () => {
  const { t } = useTranslation("paymentPage");

  return (
    <div className="bg-white min-h-screen flex flex-col items-center justify-center px-6">
      <div>
        <img src="/road-closed-taxi.svg" alt="Payment Failed" className="w-48 h-48" />
      </div>
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          {t("tapPaymentFailedTitle")}
        </h2>
        <p className="text-gray-600 text-lg leading-relaxed max-w-sm">
          {t("tapPaymentFailedBody")}
        </p>
      </div>
    </div>
  );
};

export default TapPaymentFailedCard;
